export { default as withBaseProps } from './withBaseProps';
//# sourceMappingURL=index.js.map